import {Injectable} from '@angular/core';
import {ApiService} from '../../../shared/services/api/api.service';
import {
  ICreateSettings,
  IGetSettingsFilter,
  ISettings,
  ISetTwoFactorSettings
} from '../interfaces/service-crud-interfaces';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private readonly apiService: ApiService) {
  }

  getUserSettings(data: IGetSettingsFilter, isSuperAdmin: boolean = false): Observable<any[]> {
    const controller = isSuperAdmin === true ? 'system-settings' : 'user-settings'
    return this.apiService.post<ISettings[]>(`${controller}/find-settings`, {filter: data.filter ?? []});
  }


  createSettings(data: ICreateSettings[], isSuperAdmin: boolean = false): Observable<{ isSuccess: boolean }> {
    const controller = isSuperAdmin === true ? 'system-settings' : 'user-settings'
    return this.apiService.post<{ isSuccess: boolean }>(`${controller}/create`, {settings: data});
  }

  setTwoFactorKey(data: ISetTwoFactorSettings): Observable<{ isSuccess: boolean }> {
    return this.apiService.patch<{ isSuccess: boolean }>(`user-settings/set-verify-two-factor-key`, data);
  }


  deleteSettings(data: ICreateSettings[], isSuperAdmin: boolean = false): Observable<{ isSuccess: boolean }> {
    const controller = isSuperAdmin === true ? 'system-settings' : 'user-settings'
    return this.apiService.post<{ isSuccess: boolean }>(`${controller}/delete`, data);
  }

  generateQRCode() {
    return this.apiService.get<{ qrCodeImage: string, secret: string }>(`user-settings/2fa/generate-qr-code`)
  }

  verifyQRCode(code: string, secret?: string) {
    return this.apiService.post<{ success: boolean }>(`user-settings/2fa/verify-qr-code`, {code, secret})
  }
}
